import {AbTestingBaseStrategy, EmptyAbTestData} from "../ab-testing-base.strategy";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {ABTestingController_GetTestsForAnonymousPlayerRequest} from "../../../api/api.service";
import {IAbTestingData, IAbTestingFeature} from "../../ab-testing-feature-data-provider.service.interface";

export class AbTestingForAnonymousUserStrategy extends AbTestingBaseStrategy {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._anonymousTestData = EmptyAbTestData;
        this._storedAuthorizedTestData = this._readAuthorizedTestDataFromLocalStorage();

        this._loadAnonymousTestDataPromise = this._loadAnonymousTestData();

        makeObservable(this);
    }

    @observable.ref
    private _anonymousTestData: IAbTestingData;

    private readonly _storedAuthorizedTestData: IAbTestingData;

    private readonly _loadAnonymousTestDataPromise: Promise<void>;

    waitForLoadTestData(): Promise<void> {
        return this._loadAnonymousTestDataPromise;
    }

    private async _loadAnonymousTestData(): Promise<void> {

        try {

            if(!this.services.configuration.servicesConfigs.AbTesting.isAnonymousPlayerSupportEnabled) {
                return;
            }

            const request: ABTestingController_GetTestsForAnonymousPlayerRequest = {
                brandId: this.services.sdk.getBrandID(),
                subBrandId: this.services.sdk.getSubBrandID(),
                countryCode: this.services.sdk.getCountryIso3(),
                isMobile: this.services.device.os.isMobileOS
            };

            if(this.anonymousPlayerId) {
                request.anonymousPlayerId = this.anonymousPlayerId;
            }

            const response = await this.services.api.aBTestingController.getTestsForAnonymousPlayer(request);

            runInAction(() => {
                if(response.AnonymousPlayerId) {
                    this.anonymousPlayerId = response.AnonymousPlayerId;
                }

                this._anonymousTestData = {
                    Features: response.Features ?? {},
                    ErrorDescription: null,
                    AnonymousPlayerId: this.anonymousPlayerId
                }
            });
        } catch (err) {
            this.services.logger.error('Failed to load anonymous user A/B testing data', err);
        }

    }

    getFeature(featureName: string): IAbTestingFeature | null {
        let feature = this._findFeature(featureName, this._anonymousTestData);
        if(feature) {
            return feature;
        }

        return this._findFeature(featureName, this._storedAuthorizedTestData);
    }

}